import { MdClose } from 'react-icons/md';
import styled from 'styled-components';

export const StyledCloseIcon = styled(MdClose)`
  position:absolute;
  right:7px;
  top:7px;
  cursor: pointer;
`;